import { render, staticRenderFns } from "./PDFSelection.vue?vue&type=template&id=6accdc98&scoped=true"
import script from "./PDFSelection.vue?vue&type=script&lang=js"
export * from "./PDFSelection.vue?vue&type=script&lang=js"
import style0 from "./PDFSelection.vue?vue&type=style&index=0&id=6accdc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accdc98",
  null
  
)

export default component.exports